function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pixel-this-clothing-/-icons-/-square---dark",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#363636",
  strokeWidth: 2,
  strokeLinecap: "round",
  x: 1.72226511,
  y: 1.72226511,
  width: 12.5554698,
  height: 12.5554698
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#363636",
  fill: "#FFFFFF",
  x: 6.77773489,
  y: 0.5,
  width: 2.44453023,
  height: 2.44453023
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#363636",
  fill: "#FFFFFF",
  x: 6.77773489,
  y: 13.0554698,
  width: 2.44453023,
  height: 2.44453023
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#363636",
  fill: "#FFFFFF",
  transform: "translate(14.277735, 8.000000) rotate(-270.000000) translate(-14.277735, -8.000000) ",
  x: 13.0554698,
  y: 6.77773489,
  width: 2.44453023,
  height: 2.44453023
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#363636",
  fill: "#FFFFFF",
  transform: "translate(1.722265, 8.000000) rotate(-270.000000) translate(-1.722265, -8.000000) ",
  x: 0.5,
  y: 6.77773489,
  width: 2.44453023,
  height: 2.44453023
}));

function SvgSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pixel this clothing / icons / square - dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.5cb54df2.svg";
export { ForwardRef as ReactComponent };